import styled, { css } from 'styled-components';

const cardCSS = css`
    padding: ${({ $paddingOverride }) => $paddingOverride || 'var(--gameday-section-padding-sm)'};
    background-color: var(--gameday-background-color);
    color: var(--gameday-primary-font-color);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin:${({ $marginOverride }) => $marginOverride || '24px 16px'};
    max-height: ${({ $maxHeightOverride }) => $maxHeightOverride || 'calc(100vh - 32px)'};
    overflow: auto;
    ${({ $matchup }) => {
            if ($matchup) {
                return `
                    position: sticky;
                    top: 0;
                    z-index: 9;
                `;
            }
        }};
`;

export const CardWrapper = styled.div`
    ${({ $displayFlat }) =>
        $displayFlat
            ? ` padding: 0px;
                margin: 0;
                overflow: auto;`
            : cardCSS
}
`;
